import actions from './actions';
import mutations from './mutations';

const state = {
    error: {},
    events: {
        mcd: [],
        summit: [],
        'live-course': [],
        sps: []
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
